var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigitalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.168,
    height: 68.339,
    viewBox: "0 0 81.168 68.339",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1626",
    "data-name": "Rectangle 1626",
    width: 81.168,
    height: 68.339,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "digital-icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3814",
    "data-name": "Group 3814",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60303",
    "data-name": "Path 60303",
    d: "M33.422,30.657a1.36,1.36,0,0,1-.873-.317l-7.293-6.133H3.07A3.073,3.073,0,0,1,0,21.137V3.07A3.073,3.073,0,0,1,3.07,0H39.376a3.073,3.073,0,0,1,3.07,3.07V21.137a3.073,3.073,0,0,1-3.07,3.07h-4.6v5.1a1.353,1.353,0,0,1-.783,1.227,1.338,1.338,0,0,1-.571.127M3.07,2.708a.36.36,0,0,0-.362.362V21.137a.362.362,0,0,0,.362.362H25.748a1.35,1.35,0,0,1,.873.317l5.443,4.577v-3.54A1.355,1.355,0,0,1,33.422,21.5h5.954a.365.365,0,0,0,.362-.362V3.07a.362.362,0,0,0-.362-.362Z",
    transform: "translate(0 -0.001)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60304",
    "data-name": "Path 60304",
    d: "M6.1,6.521H4.38a1.354,1.354,0,0,1,0-2.708H6.1a1.354,1.354,0,0,1,0,2.708",
    transform: "translate(8.263 10.41)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60305",
    "data-name": "Path 60305",
    d: "M8.166,6.521H6.45a1.354,1.354,0,0,1,0-2.708H8.166a1.354,1.354,0,0,1,0,2.708",
    transform: "translate(13.915 10.41)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60306",
    "data-name": "Path 60306",
    d: "M10.236,6.521H8.52a1.354,1.354,0,0,1,0-2.708h1.716a1.354,1.354,0,1,1,0,2.708",
    transform: "translate(19.567 10.41)",
    fill: "#ec431f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60307",
    "data-name": "Path 60307",
    d: "M7.878,37.433a1.355,1.355,0,0,1-1.354-1.347l-.022-4.7L1.282,15.337A2.984,2.984,0,0,1,4.1,11.431l25.588-.112h.019a3.585,3.585,0,0,1,3.44,2.533L38.08,29.673l1.7-.015H39.8a1.356,1.356,0,0,1,.011,2.712l-2.712.019h-.011a1.357,1.357,0,0,1-1.294-.951l-5.23-16.78a.888.888,0,0,0-.851-.63H29.7l-25.584.116a.259.259,0,0,0-.22.112.255.255,0,0,0-.037.242L9.143,30.744a1.364,1.364,0,0,1,.067.422l.015,3.555,28.964-.03a1.354,1.354,0,1,1,0,2.708Z",
    transform: "translate(3.093 30.905)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60308",
    "data-name": "Path 60308",
    d: "M22.724,23.919a8.318,8.318,0,0,1-6.129-2.552,12.231,12.231,0,0,1-3.122-7.23,12.216,12.216,0,0,1,1.384-7.752,8.488,8.488,0,0,1,6.569-4.092,8.467,8.467,0,0,1,7.33,2.481A12.233,12.233,0,0,1,31.883,12c.75,6.446-2.451,11.206-7.953,11.848a10.223,10.223,0,0,1-1.2.071M22.631,4.93a8.149,8.149,0,0,0-.892.052,5.8,5.8,0,0,0-4.559,2.8,9.706,9.706,0,0,0-1.018,6.043c.455,3.913,2.649,7.9,7.454,7.334s6.028-4.935,5.577-8.845a9.737,9.737,0,0,0-2.376-5.652A5.634,5.634,0,0,0,22.631,4.93",
    transform: "translate(36.487 6.062)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60309",
    "data-name": "Path 60309",
    d: "M42.655,43.855h-.019l-26.121-.071c-2.731,0-4.958-2.656-4.958-5.909,0-2.977,2.276-5.491,4.969-5.491h.034l1.313-15.545a9.145,9.145,0,0,1,9.08-7.871H32.84a9.208,9.208,0,0,1,8.3,5.275l7.83,19.79a6.942,6.942,0,0,1-6.319,9.822M16.526,35.092a2.632,2.632,0,0,0-2.261,2.783c0,1.7,1.056,3.2,2.257,3.2l26.121.071h.011a4.238,4.238,0,0,0,3.835-6.04l-7.83-19.79a6.466,6.466,0,0,0-5.82-3.641H26.953a6.429,6.429,0,0,0-6.39,5.48L19.279,32.383H32.813l-1.1-2.548a1.354,1.354,0,0,1,2.485-1.078L36.122,33.2a1.357,1.357,0,0,1-1.242,1.9H16.526Z",
    transform: "translate(31.557 24.483)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60310",
    "data-name": "Path 60310",
    d: "M21.456,16.849H11.346a1.354,1.354,0,1,1,0-2.708h10.11a1.354,1.354,0,1,1,0,2.708",
    transform: "translate(27.283 38.611)",
    fill: "#051631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60311",
    "data-name": "Path 60311",
    d: "M75.782,20.3H2.63a1.354,1.354,0,1,1,0-2.708H75.782a1.354,1.354,0,1,1,0,2.708",
    transform: "translate(3.484 48.036)",
    fill: "#051631"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigitalIcon);
export default __webpack_public_path__ + "static/media/digital-icon.45bdde0372b13a60c8c73f76207285f5.svg";
export { ForwardRef as ReactComponent };